import { useState, useEffect } from 'react'
import { Button } from '@mui/material'
import { v4 as uuid } from 'uuid';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import { useSelector } from 'react-redux';
import React from 'react'

export default function NewUserExerciseForm({ addUserProgram, existingItem }) {
    const [exerciseType, setExerciseType] = useState(0)
    const filter = createFilterOptions();
    const userPrograms = useSelector((state) => state.userProgram.userProgram)
    const [programValue, setProgramValue] = useState(null);
    const [exerciseName, setExerciseName] = useState('')
    const [description, setDescription] = useState('')
    const [instructions, setInstructions] = useState('')
    const [existingId, setExistingId] = useState('')

    const [folder, setFolder] = useState('')
    const [link, setLink] = useState('')
    const [thumbnail, setThumbnail] = useState('')
    const [idx, setIdx] = useState(0)

    const [externalLinkUrl, setExternalLinkUrl] = useState('')
    const [externalLinkTitle, setExternalLinkTitle] = useState('')


    const uniqueUserPrograms = []
    userPrograms && userPrograms.map(prog => {
        if (!uniqueUserPrograms.find(p => p.splitCategory === prog.splitCategory)) {
            uniqueUserPrograms.push(prog)
        }
        return null
    });

    const handleChange = (event) => {
        setExerciseType(event.target.value);
    };

    const handleSubmit = (e) => {
        e.preventDefault()
        const exercise = {
            id: existingItem ? existingId : uuid(),
            name: exerciseName,
            description: description,
            instructions: instructions,
            metricType: exerciseType,
            splitCategory: programValue.splitCategory,
            isCategory: false,
            folder: folder,
            link: link,
            thumbnail: thumbnail,
            idx: idx,
            externalLinkTitle: "externalLinkTitle",
            externalLinkUrl: externalLinkUrl
        }
        addUserProgram(exercise)
    }

    useEffect(() => {
        if (existingItem) {
            const foundItem = userPrograms.find(p => p.id === existingItem.id)
            if (foundItem) {
                setExistingId(foundItem.id)
                setExerciseName(foundItem.name)
                setDescription(foundItem.description)
                setInstructions(foundItem.instructions)
                setProgramValue({
                    splitCategory: foundItem.splitCategory,
                });
                setExerciseType(foundItem.metricType)
                setFolder(foundItem.folder)
                setLink(foundItem.link)
                setThumbnail(foundItem.thumbnail)
                setIdx(foundItem.idx)
                if (foundItem.externalLinkTitle !== undefined && foundItem.externalLinkUrl !== undefined) {
                    setExternalLinkTitle(foundItem.externalLinkTitle)
                    setExternalLinkUrl(foundItem.externalLinkUrl)
                }
            }
        }
    }, [existingItem, userPrograms]);

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
            }}
        >
            <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
                <TextField
                    margin="dense"
                    required
                    size='small'
                    fullWidth
                    id="name"
                    label="Navn på øvelse"
                    name="name"
                    autoComplete="name"
                    autoFocus
                    value={exerciseName}
                    onChange={(event) => {
                        setExerciseName(event.target.value);
                    }}
                />
                <TextField
                    margin="dense"
                    // required
                    size='small'
                    fullWidth
                    name="description"
                    label="Beskrivelse"
                    id="description"
                    autoComplete="description"
                    value={description}
                    onChange={(event) => {
                        setDescription(event.target.value);
                    }}
                />

                <TextField
                    margin="dense"
                    size='small'
                    // required
                    fullWidth
                    name="instructions"
                    label="Dosering"
                    id="instructions"
                    autoComplete="instructions"
                    value={instructions}
                    onChange={(event) => {
                        setInstructions(event.target.value);
                    }}
                />
                <Autocomplete
                    value={programValue}
                    onChange={(event, newValue) => {
                        if (typeof newValue === 'string') {
                            setProgramValue({
                                splitCategory: newValue,
                            });
                        } else if (newValue && newValue.inputValue) {
                            // Create a new value from the user input
                            setProgramValue({
                                splitCategory: newValue.inputValue,
                            });
                        } else {
                            setProgramValue(newValue);
                        }
                    }}
                    filterOptions={(options, params) => {
                        const filtered = filter(options, params);

                        const { inputValue } = params;
                        // Suggest the creation of a new value
                        const isExisting = options.some((option) => inputValue === option.splitCategory);
                        if (inputValue !== '' && !isExisting) {
                            filtered.push({
                                inputValue,
                                splitCategory: `Legg til "${inputValue}"`,
                            });
                        }
                        return filtered;
                    }}
                    margin="dense"
                    size='small'
                    selectOnFocus
                    clearOnBlur
                    handleHomeEndKeys
                    id="programName"
                    options={uniqueUserPrograms}
                    getOptionLabel={(option) => {
                        // Value selected with enter, right from the input
                        if (typeof option === 'string') {
                            return option;
                        }
                        // Add "xxx" option created dynamically
                        if (option.inputValue) {
                            return option.inputValue;
                        }
                        // Regular option
                        return option.splitCategory;
                    }}
                    renderOption={(props, option) => <li {...props}>{option.splitCategory}</li>}
                    sx={{ width: '100%', mt: 1 }}
                    freeSolo
                    renderInput={(params) => (
                        <TextField {...params} label="Program *" />
                    )}
                />

                <FormControl fullWidth sx={{ mt: 1.5, mb: 0.5 }}>
                    <InputLabel id="exerciseType">Øvelsetype *</InputLabel>
                    <Select
                        margin="dense"
                        size='small'
                        labelId="exerciseType"
                        id="exerciseType"
                        value={exerciseType}
                        label="Øvelsetype"
                        onChange={handleChange}
                        fullWidth
                    // sx={{ mt: 2}}
                    >
                        <MenuItem value={0}>Ingen</MenuItem>
                        <MenuItem value={1}>Vekt</MenuItem>
                        <MenuItem value={2}>Tid</MenuItem>
                        <MenuItem value={3}>Distanse</MenuItem>
                        <MenuItem value={4}>Antall</MenuItem>
                        <MenuItem value={5}>VAS</MenuItem>
                        <MenuItem value={6}>24h</MenuItem>
                        <MenuItem value={7}>Tid og distanse</MenuItem>
                        <MenuItem value={8}>Vekt og antall</MenuItem>
                    </Select>
                </FormControl>
                <TextField
                    margin="dense"
                    size='small'
                    // required
                    fullWidth
                    name="externalLinkUrl"
                    label="Ekstern lenke"
                    id="externalLinkUrl"
                    autoComplete="externalLinkUrl"
                    value={externalLinkUrl}
                    onChange={(event) => {
                        setExternalLinkUrl(event.target.value);
                    }}
                />
                {/* <TextField
                    margin="dense"
                    size='small'
                    // required
                    fullWidth
                    name="externalLinkTitle"
                    label="Ekstern lenketekst"
                    id="externalLinkTitle"
                    autoComplete="externalLinkTitle"
                    value={externalLinkTitle}
                    onChange={(event) => {
                        setExternalLinkTitle(event.target.value);
                    }}
                /> */}
                <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    sx={{ mt: 3, mb: 2 }}
                >
                    {existingItem ? 'Endre' : 'Legg til'}
                </Button>

            </Box>
        </Box>
    )
}